import React from 'react';
import { ChevronUp, ChevronDown, ChevronsUpDown, Building2, Users, UserPlus, Mail, Calendar } from 'lucide-react';
import { calculateLoyaltyLevel, calculateVisitFrequencyRole } from '../../../utils/loyalty';
import { anonymizeName, anonymizePhone, anonymizeEmail } from '../../../utils/customer';
const CustomerTable = ({ customers, tenantData, userData, tenants, effectiveTenantId, sortConfig, onSort, onSelect, t }) => {
    const SortIcon = ({ column }) => {
        if (sortConfig.key !== column) return <ChevronsUpDown size={11} style={{ opacity: 0.2, marginLeft: '6px' }} />;
        return sortConfig.direction === 'asc'
            ? <ChevronUp size={11} style={{ marginLeft: '6px', color: '#666' }} />
            : <ChevronDown size={11} style={{ marginLeft: '6px', color: '#666' }} />;
    };

    const formatLastVisit = (date) => {
        if (!date) return '-';
        const d = new Date(date);
        const now = new Date();
        const diffMs = now - d;
        const diffDays = Math.floor(diffMs / 86400000);
        if (diffDays === 0) return 'Bugün';
        if (diffDays === 1) return 'Dün';
        if (diffDays < 7) return `${diffDays} gün önce`;
        if (diffDays < 30) return `${Math.floor(diffDays / 7)} hafta önce`;
        if (diffDays < 365) return `${Math.floor(diffDays / 30)} ay önce`;
        return d.toLocaleDateString('tr-TR');
    };

    if (customers.length === 0) {
        return (
            <div className="card glass" style={{ padding: '4rem 2rem', textAlign: 'center' }}>
                <div style={{
                    width: '80px', height: '80px',
                    background: 'rgba(var(--primary-rgb), 0.08)',
                    borderRadius: '24px',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    margin: '0 auto 1.5rem'
                }}>
                    <Users size={36} style={{ color: 'var(--primary)' }} />
                </div>
                <h3 style={{ fontSize: '1.25rem', fontWeight: 700, marginBottom: '0.5rem', color: 'var(--text-main)' }}>
                    Henüz müşteri bulunamadı
                </h3>
                <p style={{ color: 'var(--text-muted)', maxWidth: '400px', margin: '0 auto', lineHeight: 1.6 }}>
                    Yeni müşteri ekleyerek veya QR kod ile check-in yaparak müşteri listenizi oluşturun.
                </p>
            </div>
        );
    }

    return (
        <div style={{ background: 'var(--bg-card)', borderRadius: '12px 12px 0 0', border: '1px solid var(--border)', borderBottom: 'none', overflow: 'hidden' }}>
            <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', minWidth: '900px', borderCollapse: 'collapse', textAlign: 'left' }}>
                    <thead>
                        <tr style={{ background: 'var(--bg-main)' }}>
                            <th onClick={() => onSort('name')} style={{ padding: '0.75rem 1.5rem', color: 'var(--text-muted)', cursor: 'pointer', userSelect: 'none', fontWeight: 600, fontSize: '0.8125rem' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>Müşteri <SortIcon column="name" /></div>
                            </th>
                            {!effectiveTenantId && userData?.isSuperAdmin && <th style={{ padding: '0.75rem 1.5rem', color: 'var(--text-muted)', fontWeight: 600, fontSize: '0.8125rem' }}>Business</th>}
                            <th onClick={() => onSort('points')} style={{ padding: '0.75rem 1.5rem', color: 'var(--text-muted)', cursor: 'pointer', userSelect: 'none', fontWeight: 600, fontSize: '0.8125rem' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>Seviye & Puan <SortIcon column="points" /></div>
                            </th>
                            <th onClick={() => onSort('totalSpent')} style={{ padding: '0.75rem 1.5rem', color: 'var(--text-muted)', cursor: 'pointer', fontWeight: 600, fontSize: '0.8125rem' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>Toplam Harcama <SortIcon column="totalSpent" /></div>
                            </th>
                            <th onClick={() => onSort('avgBasket')} style={{ padding: '0.75rem 1.5rem', color: 'var(--text-muted)', cursor: 'pointer', fontWeight: 600, fontSize: '0.8125rem' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>Ort. Sepet <SortIcon column="avgBasket" /></div>
                            </th>
                            <th onClick={() => onSort('lastVisit')} style={{ padding: '0.75rem 1.5rem', color: 'var(--text-muted)', cursor: 'pointer', fontWeight: 600, fontSize: '0.8125rem' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>Son Ziyaret <SortIcon column="lastVisit" /></div>
                            </th>
                            <th style={{ padding: '0.75rem 1.5rem', color: 'var(--text-muted)', userSelect: 'none', fontWeight: 600, fontSize: '0.8125rem' }}>
                                Rol
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {customers.map((customer) => {
                            const level = calculateLoyaltyLevel(customer, tenantData);
                            const visitRole = calculateVisitFrequencyRole(customer, tenantData);
                            const avgBasket = (customer.purchaseCount > 0 ? (customer.totalSpent || 0) / customer.purchaseCount : 0).toFixed(0);

                            return (
                                <tr key={customer.id} style={{ borderTop: '1px solid var(--border)', cursor: 'pointer', transition: 'background 0.2s', color: 'var(--text-main)' }} onClick={() => onSelect(customer)} className="table-row-hover">
                                    <td style={{ padding: '0.875rem 1.5rem' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                            <div style={{
                                                width: '40px', height: '40px',
                                                background: `${level.color}18`,
                                                color: level.color,
                                                borderRadius: '12px', display: 'flex',
                                                alignItems: 'center', justifyContent: 'center',
                                                fontSize: '0.8rem', fontWeight: 800,
                                                border: `2px solid ${level.color}30`,
                                                flexShrink: 0
                                            }}>
                                                {(() => {
                                                    if (customer.firstName && customer.lastName) return (customer.firstName[0] + customer.lastName[0]).toUpperCase();
                                                    if (customer.firstName) return customer.firstName[0].toUpperCase();
                                                    return '?';
                                                })()}
                                            </div>
                                            <div style={{ minWidth: 0 }}>
                                                <div style={{ fontWeight: 700, fontSize: '0.9rem', color: 'var(--text-main)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                    {anonymizeName(`${customer.firstName || ''} ${customer.lastName || ''}`) || 'İsimsiz'}
                                                </div>
                                                <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: '1px', display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                                                    {customer.phone && <span>{anonymizePhone(customer.phone)}</span>}
                                                    {customer.phone && customer.email && <span style={{ opacity: 0.4 }}>|</span>}
                                                    {customer.email && <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '160px' }}>{anonymizeEmail(customer.email)}</span>}
                                                    {customer.shortId && <span style={{ opacity: 0.5 }}>#{customer.shortId}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    {!effectiveTenantId && userData?.isSuperAdmin && (
                                        <td style={{ padding: '0.875rem 1.5rem' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.85rem', color: 'var(--text-main)' }}>
                                                <Building2 size={14} /> {tenants[customer.tenantId] || 'System'}
                                            </div>
                                        </td>
                                    )}
                                    <td style={{ padding: '0.875rem 1.5rem' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <span style={{
                                                fontSize: '0.7rem', fontWeight: 700,
                                                background: `${level.color}15`,
                                                color: level.color,
                                                padding: '3px 8px', borderRadius: '6px',
                                            }}>
                                                {level.label}
                                            </span>
                                            <span style={{ fontWeight: 700, fontSize: '0.875rem', color: 'var(--text-main)' }}>{customer.points || 0}</span>
                                        </div>
                                    </td>
                                    <td style={{ padding: '0.875rem 1.5rem', fontWeight: 700, color: 'var(--text-main)', fontSize: '0.875rem' }}>
                                        ₺{(customer.totalSpent || 0).toLocaleString('tr-TR', { maximumFractionDigits: 0 })}
                                        <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)', fontWeight: 500 }}>{customer.purchaseCount || 0} sipariş</div>
                                    </td>
                                    <td style={{ padding: '0.875rem 1.5rem', fontWeight: 700, color: 'var(--text-main)', fontSize: '0.875rem' }}>₺{avgBasket}</td>
                                    <td style={{ padding: '0.875rem 1.5rem', fontSize: '0.8125rem', color: 'var(--text-muted)' }}>
                                        {formatLastVisit(customer.lastInteractionAt)}
                                    </td>
                                    <td style={{ padding: '0.875rem 1.5rem' }}>
                                        {visitRole && (
                                            <span style={{
                                                fontSize: '0.7rem',
                                                background: `${visitRole.color || '#10b981'}12`,
                                                color: visitRole.color || '#10b981',
                                                padding: '3px 10px', borderRadius: '6px', fontWeight: 700,
                                                whiteSpace: 'nowrap'
                                            }}>
                                                {visitRole.label}
                                            </span>
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            <style>{`
                .table-row-hover:hover {
                    background: rgba(var(--primary-rgb), 0.03) !important;
                }
            `}</style>
        </div>
    );
};

export default CustomerTable;
